// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"google-preferred-sources-button_wrapper__SnPAt"};